module.exports = __webpack_public_path__ + "media/images/menu_bg-e3995a0494bc79fb0c5b14dddb15ff20.png";